import * as React from "react";
const SvgData = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M8 7.333c-1.789 0-3.236-.272-4.342-.816C2.553 5.972 2 5.356 2 4.667c0-.7.553-1.32 1.658-1.859C4.764 2.27 6.211 2 8 2c1.789 0 3.236.27 4.342.808C13.447 3.348 14 3.967 14 4.667c0 .689-.553 1.305-1.658 1.85-1.106.544-2.553.816-4.342.816Zm0 3.334c-1.622 0-3.028-.245-4.217-.734C2.594 9.444 2 8.856 2 8.167V6.5c0 .433.208.808.625 1.125.417.317.933.578 1.55.783.617.206 1.272.356 1.967.45C6.836 8.953 7.456 9 8 9c.556 0 1.178-.047 1.867-.142a11.32 11.32 0 0 0 1.958-.441c.617-.2 1.133-.459 1.55-.775.417-.317.625-.698.625-1.142v1.667c0 .689-.594 1.277-1.783 1.766-1.19.49-2.595.734-4.217.734ZM8 14c-1.622 0-3.028-.244-4.217-.733C2.594 12.777 2 12.189 2 11.5V9.833c0 .434.208.809.625 1.125.417.317.933.578 1.55.784.617.205 1.272.355 1.967.45.694.094 1.314.141 1.858.141.556 0 1.178-.047 1.867-.141a11.326 11.326 0 0 0 1.958-.442c.617-.2 1.133-.458 1.55-.775.417-.317.625-.697.625-1.142V11.5c0 .689-.594 1.278-1.783 1.767C11.027 13.756 9.622 14 8 14Z"
    />
  </svg>
);
export default SvgData;
